module.exports = __webpack_public_path__ + "static/media/ppe_per_flo_dev.d094aaad.png";